function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6499 3.54997C14.1399 3.54997 15.6999 3.53 16.1599 3.61C17.6799 3.9 18.3499 4.46998 19.0199 5.76998",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8499 4.89999L13.4299 3.58002L14.7099 2.20001",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.40998 10.4C3.86998 10.4 1.72998 10.79 1.72998 12.29C1.72998 13.79 3.87998 14.18 6.40998 14.18C8.93998 14.18 11.09 13.79 11.09 12.29C11.09 10.79 8.93998 10.4 6.40998 10.4Z",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.40992 8.19C8.03992 8.19 9.39992 6.82001 9.39992 5.20001C9.39992 3.58001 8.02992 2.20999 6.40992 2.20999C4.78992 2.20999 3.41992 3.58001 3.41992 5.20001C3.41992 6.82001 4.71992 8.19 6.40992 8.19Z",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3499 17.48C14.8099 17.48 12.6699 17.87 12.6699 19.37C12.6699 20.87 14.8199 21.26 17.3499 21.26C19.8799 21.26 22.0299 20.87 22.0299 19.37C22.0299 17.87 19.8799 17.48 17.3499 17.48Z",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3499 15.27C18.9799 15.27 20.3399 13.9 20.3399 12.28C20.3399 10.66 18.9699 9.29001 17.3499 9.29001C15.7299 9.29001 14.3599 10.66 14.3599 12.28C14.3599 13.9 15.6599 15.27 17.3499 15.27Z",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M8.98011 19.7C8.49011 19.7 6.93011 19.72 6.47011 19.64C4.95011 19.35 4.28011 18.78 3.61011 17.48",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M7.78003 18.36L9.20003 19.67L7.91003 21.05",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgSwitch = function SvgSwitch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSwitch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Switch.52a17f11.svg";
export { ForwardRef as ReactComponent };